export class Telefone {
  constructor() {
    this.id = 0;
    this.numero = '';
  }
}
